import { createModel, createSelector } from "nyax";
import { ModelBase } from "src/store/ModelBase";
import { DataPermissionEntityModel } from "src/store/models/entity/dataPermission/entity";
import { DataTableEntityModel } from "src/store/models/entity/dataTable/entity";
import { DataTableHelperModel } from "src/store/models/entity/dataTable/helper";

export const DataTableDetailUIModel = createModel(
  class extends ModelBase {
    private get _id() {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      return this.containerKey!;
    }
    public selectors() {
      return {
        dataTableDetail: createSelector(
          () => this.getContainer(DataTableEntityModel).state.byId,
          () => this.getContainer(DataPermissionEntityModel).state.byId,
          (dataTableById, permissionById) => {
            const dataTable = dataTableById[this._id];
            return dataTable
              ? {
                  ...dataTable,
                  permissionValues:
                    permissionById[this._id]?.permissionValues ?? [],
                }
              : null;
          }
        ),
      };
    }

    public effects() {
      return {
        ...super.effects(),
        requestDetail: async () => {
          await this.getContainer(DataTableHelperModel).actions.getById.dispatch({
            dataTableId: this._id,
          });
        },
      };
    }
  },
  {
    isDynamic: true,
    isLazy: true,
  }
);
